import styled, {css} from 'styled-components';

import type {Size, StyledProps} from './types';

import {getColor, ms} from '../../styles';
import {platform} from '../../utils/platform';
import {Text} from '../Text';
import {View} from '../View';

const fontSizeScheme: Record<Size, number> = {
  la: 20,
  me: 13,
};

export const Container = styled(View)`
  flex-direction: row;
  align-items: center;
  min-width: 0;
`;

const SText = styled(Text).attrs({
  nativeProps: {numberOfLines: 1},
})<StyledProps>`
  line-height: ${ms(18)};
  letter-spacing: ${ms(-0.08)};
  color: ${p => getColor(p.color || 'text3')(p)};

  ${platform.isWeb &&
  css`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `};
`;

export const Key = styled(SText)<{size: Size}>`
  font-size: ${p => ms(fontSizeScheme[p.size ?? 'me'])};

  ${platform.isNative &&
  css`
    max-width: 80%;
  `};
`;

export const Value = styled(SText)<{size: Size}>`
  font-size: ${p => ms(fontSizeScheme[p.size ?? 'me'])};
  flex-shrink: 1;
`;

export const DotsLine = styled(Text).attrs({nativeProps: {numberOfLines: 1}})<{
  size: Size;
}>`
  font-size: ${p => ms(fontSizeScheme[p.size ?? 'me'])};
  line-height: ${ms(18)};
  flex: 1 2 ${ms(20)};
  color: ${getColor('text3')};
  opacity: 0.3;
  padding: 0 ${ms(7)};
  min-width: ${ms(20)};

  ${platform.isWeb &&
  css`
    overflow: hidden;
    text-overflow: ellipsis;
  `};
`;
